import React from "react";
import Earth from "./component/Earth";

function App() {
  return (
    <div className="App">
      <Earth />
    </div>
  );
}

export default App;
